import { getLayout } from "@/Utils/auth";
import { ControlTranslation } from "AlignComponents";
import classNames from "classnames";
import { LuPin, LuPinOff } from "react-icons/lu";
import Menu from "./Menu";

export const AlignUIRender = ({ sideBarPinned, settingAllowed, mainMenu, mainMenuRef, requestMenu, requestMenuRef, moduleMenu, moduleMenuRef, switchSideBarState, forcePinSideBar, companyInformation, routeToObject }: any) => {
	return (
		<>
			<div
				id="aside"
				className={classNames([{ unpinned: !sideBarPinned }])}
			>

				<div className="d-flex align-items-center">

					{
						getLayout()?.isEqual("RTL") ? (
							<img
								src={require("@/Assets/Images/ar-logo-dark.png").default}
								className="aside-logo"
							/>
						) : (
							<img
								src={require("@/Assets/Images/logo-dark.png").default}
								className="aside-logo"
							/>
						)
					}

					<div className="aside-control ms-auto" onClick={switchSideBarState}>
						{
							sideBarPinned ? (
								<LuPinOff size="18" />
							) : (
								<LuPin size="18" />
							)
						}
					</div>
				</div>

				<hr />

				<p className="aside-title">
					<ControlTranslation system={true} controlId="lblmainmenu" />
				</p>
				<Menu ref={mainMenuRef} menu={mainMenu} isSubMenu={false} forcePinSideBar={forcePinSideBar} />

				<p className="aside-title">
					<ControlTranslation system={true} controlId="lblrequests" />
				</p>
				<Menu ref={requestMenuRef} menu={requestMenu} isSubMenu={false} forcePinSideBar={forcePinSideBar} />

				<p className="aside-title">
					<ControlTranslation system={true} controlId="lblmodules" />
				</p>
				<div className="module-menu">
					<Menu ref={moduleMenuRef} menu={moduleMenu} isSubMenu={false} forcePinSideBar={forcePinSideBar} />
				</div>
			</div>
		</>
	)
};
